import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import StoreContext from "./../../Store/Context";
import { Row, Col, Button, Label, Container, FormGroup, Form, Input } from "reactstrap";
import { LOGO_SCHOOL } from "./../Constants/SrcImages";
import { url } from "./../Constants/Services";
import "./../../../src/www/css/Login.css";

function initialState() {
  return { user: "", password: "" };
}

async function login({ user, password }) {
  if (user.length > 0 && password.length > 0) {
    const dataBody = {
      user,
      password,
    };
    
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(dataBody),
    };
    const response = await fetch(url + "LoginController/login", requestOptions);
    const result = await response.json();
    if (result.existe) {
      if (result.typ_id === "3") {
        if (result.inactivo) {
          if(result.register){
            return { error: "Su cuenta ha sido suspendida temporalmente contacte a la administración" };
          }
          else{
            return { error: "Usuario no matriculado" };
          }
        } else {
          return { token: true, usr_type: result.data[0].typ_desc, per_id: result.data[0].per_id, year: result.data[0].year };
        }
      } else if (result.typ_id === "6" || result.typ_id === "1" ) {
        if (result.inactivo) {
          return { error: "Su cuenta ha sido suspendida temporalmente contacte a la administración" };
        } else {
          if (result.n_acudido==="0") {
            return { error: "No tiene acudidos matriculados" };
          } else {
            return { token: true, usr_type: result.data[0].typ_desc, per_id: result.data[0].per_id, year: result.data[0].year };
          }
        }
      } 
      else {
          return { token: true, usr_type: result.data[0].typ_desc, per_id: result.data[0].per_id, year: result.data[0].year };
      }
    } else {
      return { error: "Usuario o contraseña incorrectos" };
    }
  } else {
    return { error: "Campos estan vacios" };
  }
}

const UserLogin = () => {
  const [values, setValues] = useState(initialState);
  const [error, setError] = useState(null);
  const { setToken,quitToken } = useContext(StoreContext);
  const history = useHistory();
  const dataUrl = {
    Profesores: "/teachers",
    Administrativos: "/admin",
    Estudiantes: "/student",
    Acudiente: "/parents",
    Direccion: "/direccion",
    Contabilidad: "/contabilidad",
  };

  function onChange(event) {
    const { value, name } = event.target;

    setValues({
      ...values,
      [name]: value
    });
    setError("");
  }

  async function onSubmit(event) {
    event.preventDefault();
    const { token, usr_type, per_id, year, error } = await login(values);
    if (token) {
      quitToken();
      setToken({ token, usr_type: dataUrl[usr_type], per_id: per_id, year: year,allow:null,per_admin:null });
      return history.push(dataUrl[usr_type] + "/home");
    }
    setError(error);
    setValues(initialState);
  }

  return (
    <React.Fragment>
      <Container>
        <Row className="mt-5">
          <Col sm={12} className="text-center mt-5">
            <h1 className="user-login__title">Iniciar sesión</h1>
          </Col>
          <Col sm={12} className="text-center mt-0">
            <img className="login-logo" alt ="" src={LOGO_SCHOOL} title="Desarrollado por www.mtechnologypanama.com Diego Martinez" />
          </Col>
          <Col sm={4}></Col>
          <Col sm={4}>
            <Form onSubmit={onSubmit}>
              <FormGroup>
                <Label for="name">Usuario </Label>
                <Input id="user" type="text" name="user" onChange={onChange} value={values.user} placeholder="Usuario" />
              </FormGroup>
              <FormGroup>
                <Label for="name">Contraseña </Label>
                <Input id="password" type="password" name="password" onChange={onChange} value={values.password} placeholder="Contraseña" />
              </FormGroup>
              {error && <div className="user-login__error font-weight-bold">{error}</div>}
              <Button type="submit" color="primary" className="user-login__submit-button">
                Entrar
              </Button>
            </Form>
          </Col>
          <Col sm={4}></Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default UserLogin;
